import common from './zh-CN/common';
import BusinessManagement from './zh-CN/BusinessManagement';
import PublishingManagement from  './zh-CN/PublishingManagement';
import StudioManagement from './zh-CN/StudioManagement';
import metrics from './zh-CN/metrics';

export default {
  ...common,
  ...BusinessManagement,
  ...PublishingManagement,
  ...StudioManagement,
  ...metrics,
}; 